document.addEventListener('DOMContentLoaded', function() {
  // Add intersection observer for animation on scroll
  const quoteSection = document.querySelector('[data-section-id="{{ section.id }}"]');
  
  if (quoteSection && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, {
      threshold: 0.3,
      rootMargin: '0px 0px -50px 0px'
    });
    
    observer.observe(quoteSection);
  }
  
  // Add smooth scroll behavior if needed
  const quoteContainer = quoteSection?.querySelector('.quote-container');
  if (quoteContainer) {
    quoteContainer.style.scrollBehavior = 'smooth';
  }
});

